import { useState } from 'react';
import { Order } from '../portals/admin/types';

export const usePayments = () => {
  const [pendingPayments, setPendingPayments] = useState<Order[]>([]);
  const [selectedPayment, setSelectedPayment] = useState<Order | null>(null);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [imageUrls, setImageUrls] = useState<Record<string, string>>({});

  const loadPendingPayments = async () => {
    try {
      const token = localStorage.getItem('adminToken');
      const response = await fetch('/api/admin/manual-payments/pending-verification', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setPendingPayments(data.orders || []);
      }
    } catch (error) {
      console.error('Failed to load pending payments:', error);
    }
  };

  const fetchImageWithAuth = async (filename: string) => {
    try {
      const token = localStorage.getItem('adminToken');
      const response = await fetch(`/api/admin/manual-payments/evidence/${filename}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const blob = await response.blob();
        const imageUrl = URL.createObjectURL(blob);
        setImageUrls(prev => ({ ...prev, [filename]: imageUrl }));
        return imageUrl;
      }
    } catch (error) {
      console.error('Failed to fetch image:', error);
    }
  };

  const verifyPayment = async (orderId: string, onSuccess: () => void) => {
    try {
      const token = localStorage.getItem('adminToken');
      const response = await fetch(`/api/admin/manual-payments/verify/${orderId}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        await loadPendingPayments();
        onSuccess();
        setShowPaymentModal(false);
        setSelectedPayment(null);
        alert('Payment verified successfully!');
      }
    } catch (error) {
      console.error('Failed to verify payment:', error);
      alert('Failed to verify payment');
    }
  };

  const rejectPayment = async (orderId: string, reason: string) => {
    try {
      const token = localStorage.getItem('adminToken');
      const response = await fetch(`/api/admin/manual-payments/reject/${orderId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ reason })
      });

      if (response.ok) {
        await loadPendingPayments();
        setShowPaymentModal(false);
        setSelectedPayment(null);
        alert('Payment rejected');
      }
    } catch (error) {
      console.error('Failed to reject payment:', error);
      alert('Failed to reject payment');
    }
  };

  return {
    pendingPayments,
    selectedPayment,
    showPaymentModal,
    imageUrls,
    setSelectedPayment,
    setShowPaymentModal,
    loadPendingPayments,
    fetchImageWithAuth,
    verifyPayment,
    rejectPayment
  };
};
